import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Space, Input } from 'antd';
import EditIcon from '../EditIcon';
import Trash from '../../Assets/images/recycle-bin.png';
import authService from '../../../Services/authService';
import Breadcrumb from "../Breadcrumb/Breadcrumb"

const States = () => {
    const [states, setStates] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    // Fetch states from the API
    const fetchStates = async () => {
        const token = authService.getCurrentadmin()?.token;
        const apiUrl = authService.getApiUrl() + 'states';

        if (!token) {
            setError('Authentication token is missing.');
            return;
        }

        try {
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }

            const result = await response.json();
            setStates(result.data); // Store the full list of states
            setFilteredStates(result.data); // Set the filtered states to the full list by default
            setError(null); // Clear any errors
        } catch (error) {
            console.error('Error fetching states:', error);
            setError('Failed to fetch states. ' + error.message);
        }
    };

    useEffect(() => {
        fetchStates();
    }, []);

    // Handle input change
    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);

        // If search term is cleared, reset filtered states to full list
        if (e.target.value === '') {
            setFilteredStates(states);
        }
    };

    // Handle search button click
    const handleSearch = () => {
        if (searchTerm.trim() === '') {
            // If search is empty, reset to full list
            setFilteredStates(states);
        } else {
            // Filter the states by the search term
            const filtered = states.filter((state) =>
                state.state_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredStates(filtered);
        }
    };

    // Handle delete action (not implemented here)
    const handleDelete = (id) => {
        console.log('Delete:', id);
        // Here, you'd make the API call to delete the record
    };

    const columns = [
        {
            title: "#",
            dataIndex: "id",
            key: "index",
            render: (text, record, index) => <span>{index + 1}</span>,
        },
        {
            title: "State",
            dataIndex: "state_name",
            key: "state_name",
        },
        {
            title: "Country Name",
            dataIndex: "country_name",
            key: "country_name",
        },
        {
            title: 'Status',
            dataIndex: 'Is_Active',
            key: 'Is_Active',
            render: (text) => (
                <span className={text === 'A' ? 'status-btn-green' : 'status-btn-red' }>
                    {text === 'A' ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            title: "Actions",
            key: "actions",
            render: (text, record) => (
                <Space size="middle">
                    <Link to={`/admin/states/edit-state/${record.id}`} className="me-1 btn btn-sm bg-success-light">
                        <Button type="text" icon={<EditIcon />} />
                    </Link>
                    {/* <Button
                        type="text"
                        icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                        onClick={() => handleDelete(record.id)}
                    /> */}
                </Space>
            ),
        },
    ];

    return (
        <div className='main-container'>
            <div className='container-fluid'>
                <Breadcrumb/>
                <div className='category-table'>
                    <div className='flex-cont add-cat'>
                        <div className='heading'>
                            <h3>States</h3><br></br>
                        </div>
                        <div className='add-btn'>
                            <Link to="/admin/states/add-state">Add</Link>
                        </div>
                    </div>
                    
                    <div className='filter-search'>
                        <Input
                            type='text'
                            className='category-search'
                            placeholder='Search'
                            onChange={handleInputChange} // Update search term as user types
                            value={searchTerm}
                        />
                         <Button type='submit' onClick={handleSearch}>Search</Button>
                    </div>
                    {/* Display an error message if there's an error */}
                    {error && <p className='error-message'>{error}</p>}
                    <div className='states-table' id='states_table'>
                        <Table
                            dataSource={filteredStates} // Use the filtered list of states
                            columns={columns}
                            pagination={{ pageSize: 10 }}
                            rowKey="id"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default States;
